module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ec-Fb-Gd.1bda23a4.png";